module.exports = __webpack_public_path__ + "img/sec4_4.641d6382.png";